import React from "react";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import { Tooltip } from "react-tooltip";

const Container = styled.div<{ gap?: string }>(({ gap }) => ({
  display: "flex",
  flexDirection: "column",
  gap: gap ? gap : "1rem",
}));

const LabelWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.4rem",
  fontWeight: theme.fontWeight.medium,
  fontSize: "1.6rem",
  lineHeight: "1.6rem",

  ".required": {
    color: theme.color.orange,
    fontSize: "1.2rem",
  },
}));

type Props = {
  label?: string;
  children?: React.ReactNode;
  required?: boolean;
  notice?: boolean;
  notiOnClick?: () => void;
  gap?: string;
  tooltip?: boolean;
  tooltipContent?: React.ReactNode;
  warning?: boolean;
};
const LabelWithInput = ({
  children,
  label,
  required = false,
  notice,
  notiOnClick,
  gap,
  tooltip,
  tooltipContent,
  warning,
}: Props) => {
  const theme = useTheme();
  return (
    <Container gap={gap}>
      {label && (
        <LabelWrapper>
          {label}
          {required && <span className="required">*</span>}
          {notice && (
            <button
              type="button"
              onClick={notiOnClick}
              style={{
                display: "flex",
              }}>
              <Image
                src={
                  warning
                    ? theme.image.warning_circle.default
                    : theme.image.question_icon.default
                }
                size="1.6rem"
              />
            </button>
          )}
          {tooltip && (
            <>
              <button type="button" data-tooltip-id="my-tooltip">
                <Image src={theme.image.warning_circle.default} size="1.6rem" />
              </button>

              <Tooltip
                openOnClick={true}
                id="my-tooltip"
                arrowColor="transparent"
                place="bottom-start"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.05)",
                  padding: "1.2rem",
                  maxWidth: "28.4rem",
                  borderRadius: "0.4rem",
                  fontWeight: theme.fontWeight.medium,
                  lineHeight: "2.4rem",
                  zIndex: 9999,
                }}>
                {tooltipContent}
              </Tooltip>
            </>
          )}
        </LabelWrapper>
      )}

      {children}
    </Container>
  );
};

export default LabelWithInput;
